require("core-js/modules/es6.function.name");

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}

RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;
module.exports = RavenConfigError;